import * as request from "@/utils/requestTog";

export default {
  // 招聘任务列表
  recruitTaskList(data) {
    return request.get("/v1/hr/recruit/task/list", data);
  },
  // 招聘任务详情
  recruitTaskDetail: (data) => {
    return request.get(`/v1/hr/recruit/task/view/${data.id}`);
  },
  // 行业类型列表
  industryType(data) {
    return request.post("/v1/hr/recruit/task/type/list", data);
  },
  // 招聘岗位预设标签列表
  recruitLabelList(data) {
    return request.post("/v1/hr/recruit/label/list", data);
  },
  // 创建招聘任务
  recruitTaskAdd(data) {
    return request.post("/v1/hr/recruit/task/task_store", data);
  },
  // 招聘任务数量
  recruitTaskCount(data) {
    return request.post("/v1/hr/recruit/task/count", data);
  },
  //岗位发布选项卡数量
  taskListTabNum(data) {
    return request.get("/v1/hr/recruit/task/all_count", data);
  },
  // 招聘任务修改
  recruitTaskUpdate: (id, data) => {
    return request.put(`/v1/hr/recruit/task/update/${id}`, data);
  },
  // 招聘任务删除
  recruitTaskDelete: (data) => {
    return request.post(`/v1/hr/recruit/task/delete/${data.id}`);
  },
  // 招聘任务审核
  recruitTaskCheck: (id, data) => {
    return request.post(`/v1/hr/employee/examine/${id}`, data);
  },
  // 获取候选人报名员工数量接口
  getCandidateNum: (data) => {
    return request.get("/v1/hr/employee/task/count", data);
  },
  // 候选人获取状态列表
  getTaskStatusList: (data) => {
    return request.get("/v1/hr/employee/task/status/list", data);
  },

  /** ---------- 员工管理 ---------- **/
  // 员工列表
  employeeList: (data) => {
    return request.get("/v1/hr/employee/list", data);
  },
  // 项目员工列表
  employeeProjectList: (data) => {
    return request.get("/v1/hr/employee/project/list", data);
  },
  // 项目员工列表
  multSetRecruitStatus: (data) => {
    return request.post("/v1/hr/employee/batch/update/status", data);
  },

  // 批量修改员工面试信息
  multUpdateMsSet: (data) => {
    return request.post("/v1/hr/employee/interview/config", data);
  },
  // 发送面试邀约短信
  sendMSinvitedMsg: (data) => {
    return request.post("/v1/hr/employee/interview/sms_new", data);
  },
  // 招聘阶段-转入面试结果
  joinInterviewResult: (data) => {
    return request.post("/v1/hr/employee/join/interview/result", data);
  },
  /** 候选人签到状态：id 候选人ID，is_checkin 1已签到 2未签到 */
  updateEmployeeIsCheckin(data) {
    return request.post("/v1/hr/employee/update/employee/is_checkin", data);
  },

  // 简历库系统统计
  resumeLibrarySystemCount(data) {
    return request.get("/v1/hr/employee/task/tab_count", data);
  },
  // 简历库分组树
  hrDepartmentList(data) {
    return request.get("/v1/hr/department/list", data);
  },
  // 简历库分组下拉
  groupList(data) {
    return request.get("groupList", data);
  },
  // 项目列表
  projectList(data) {
    return request.get("projectList", data);
  },
  // 转入候选人
  toCandidate(data) {
    return request.put("toCandidate", data);
  },
  // 分组调整
  mergeDepartment(data) {
    return request.post("mergeDepartment", data);
  },
  // 创建简历库分组
  createHrDepartmentGroup(data) {
    return request.post("createHrDepartmentGroup", data);
  },
  // 编辑简历库分组名称
  saveHrDepartmentGroupName(id, data) {
    return request.put(`saveHrDepartmentGroupName('${id}')`, data);
  },
  deleteHrDepartment(id, data = {}) {
    return request.deleteById(`deleteHrDepartment('${id}')`, data);
  },



  

  // 员工列表-用作负责人-下拉框
  employeeGetList: "/v1/hr/employee/getlist",
  //创建员工
  addEmployee: "/v1/hr/employee/store",
  //员工批量导入,
  multImportEmployee: "/v1/hr/employee/import",
  // 员工详情
  employeeDetail: (e) => {
    return `/v1/hr/employee/view/${e}`;
  },
  // 编辑员工
  employeeEdit: (e) => {
    return `/v1/hr/employee/update/${e}`;
  },
  // 离职员工
  employLeave: (e) => {
    return `/v1/hr/employee/leave/${e}`;
  },

  // 申请离职列表
  getLeaveStaffList: "/v1/hr/employee/leave_job/index",
  // 审核离职员工
  examineLeave: "/v1/hr/employee/leave_job/examine",
  // 移入黑名单
  moveToBlacklist: "/v1/hr/employee/black_list/create",
  // 删除
  quitDeletePerson: (id) => {
    return `/v1/hr/employee/leave_job/delete/${id}`;
  },
  // 重新入职
  reEmployment: (id) => {
    return `/v1/hr/employee/leave/${id}`;
  },
  // 添加离职员工
  addLeaveStaff: "/v1/hr/employee/leave_job/apply",
  // 删除员工
  employeeAllImportDelete: "/v1/hr/employee/delete",
  // 是否发送签约短信
  isSendEsignSms: "/v1/hr/esign/sms",
  // 人员同步
  employeeSync: "/v1/hr/employee/sync",
  // 批量设置员工面试失败
  interviewCannel: "/v1/hr/employee/interview/cannel",
  // 已签约未同步员工数量
  sureSyncEmployeeNum: "/v1/hr/employee/sure/sync/num",
  // 提交员工给用工企业
  submitEmployeeToEmployment: "/v1/hr/employee/submit",
  // 项目人员合并|调整|分配
  projectMerge: "/v1/hr/employee/project/merge",
  // 项目人员|待审核列表|审核
  personCheck: "/v1/hr/employee/project/examine",
  // 删除项目
  projectDelete: (e) => {
    return `/v1/hr/projecthr/del/${e}`;
  },
  // 解除绑定关系
  deleteEmployeeProject: "/v1/hr/employee/project/delete",
  // 项目数量
  getHrProjectNum: "/v1/hr/projecthr/counting",
};
